// extracted by mini-css-extract-plugin
export default {"editFormTableList":"EditFormTableList_editFormTableList__-I3eO"};